<template>
  <span class="lds-dual-ring" v-if="loading"></span>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.lds-dual-ring {
  display: inline-block;
  height: 16px;
  left: 100%;
  position: sticky;
}
.lds-dual-ring:after {
  content: ' ';
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
